var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('b-container',[_c('div',{staticClass:"section-title"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('p',[_c('small',[_vm._v(_vm._s(_vm.smallText))])])]),_c(_vm.componentName,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }